import { Component } from '@angular/core';

@Component({
  selector: 'app-update',
  standalone: true,
  imports: [],
  templateUrl: './app-update.component.html',
  styleUrl: './app-update.component.scss',
})
export class AppUpdateComponent {
  activateUpdate() {
    window.location.reload();
  }
}
